import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllHouseholdAccounts, addAllProposalAccounts, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllHouseholdAccounts, resetSelectAllProposalAccounts, resetSelectedAccounts, resetSelectedBenchmark, resetSelectedInvestmentStrategy, resetSelectedProposalAccount, selectAccount, selectBenchmarkId, selectHousehold, selectInvestmentStrategyId, selectProposalAccount, setAccountResultsLoaded, setImportType, setPortfolioImportType, setProposalAccountImportType, setSearchType, toggleSelectAllHouseholdAccounts, toggleSelectAllProposalAccounts, } from './actions';
import { VRGL_HOUSEHOLD } from 'IntegrationsApp/ts/constants';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const selectedHousehold = createReducer(null, on(selectHousehold, (state, { selectedHousehold: newHousehold }) => {
    return newHousehold;
}));
export const selectAllHouseholdAccounts = createReducer(false, on(toggleSelectAllHouseholdAccounts, (state) => {
    return !state;
}), on(resetSelectAllHouseholdAccounts, () => {
    return false;
}));
export const selectedBenchmarkId = createReducer(null, on(selectBenchmarkId, (state, { newSelectedBenchmarkId }) => {
    return newSelectedBenchmarkId;
}), on(resetSelectedBenchmark, () => {
    return null;
}));
export const selectedInvestmentStrategyId = createReducer(null, on(selectInvestmentStrategyId, (state, { newSelectedInvestmentStrategyId }) => {
    return newSelectedInvestmentStrategyId;
}), on(resetSelectedInvestmentStrategy, () => {
    return null;
}));
export const selectedProposalAccounts = createReducer([], on(selectProposalAccount, (state, { newSelectedProposalAccountName: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setProposalAccountImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllProposalAccounts, (state, { accounts }) => {
    return accounts.map((account) => {
        return { id: account.name, importAsSingleHolding: false };
    });
}), on(resetSelectedProposalAccount, () => {
    return [];
}));
export const selectAllProposalAccounts = createReducer(false, on(toggleSelectAllProposalAccounts, (state) => {
    return !state;
}), on(resetSelectAllProposalAccounts, () => {
    return false;
}));
export const searchType = createReducer(VRGL_HOUSEHOLD, on(setSearchType, (state, { newSearchType }) => {
    return newSearchType;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllHouseholdAccounts, (state, { accounts }) => {
    return accounts.map((account) => {
        return { id: account.account, importAsSingleHolding: false };
    });
}), on(resetSelectedAccounts, () => {
    return [];
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const vrglImportHoldings = combineReducers({
    currentWizardStepIndex,
    selectedAccounts,
    selectedHousehold,
    selectAllHouseholdAccounts,
    selectedBenchmarkId,
    selectedInvestmentStrategyId,
    selectedProposalAccounts,
    selectAllProposalAccounts,
    searchType,
    portfolioImportType,
    accountResultsLoaded,
});
